<template>
    <form action="/billing/update-card" method="post" :disabled="!completed">
        <csrf></csrf>
        <div class="general-title">
            <div class="title">{{ hasCard ? 'Update Card' : 'Add Card' }}</div>
            <div class="buttons-container buttons">
                <a href="/billing/history" class="neutral-bg">Go Back<span class="fa fa-arrow-left"></span></a>
            </div>
        </div>
        <div v-if="hasCard" class="input-container">
            <div class="input-title">Current Card</div>
            <div class="input-box static-text">{{ card.brand }} ****{{ card.last4 }}</div>
        </div>
        <card-form title="New Card" @completed="completed = true"></card-form>
        <button type="submit" class="submit-standard good-bg" :disabled="!completed">{{ hasCard ? 'Update Card' : 'Add Card' }}<span class="fa fa-credit-card"></span></button>
    </form>
</template>

<script>

export default {

    props: [ 'card' ],

    data() {
        return {
            completed: false,
        };
    },

    computed: {

        hasCard() {
            return this.card && this.card.last4;
        },

    },
}

</script>



// WEBPACK FOOTER //
// resources/js/components/billing/ManageCardForm.vue